import PolandIcon from "components/Icons/FlagsIcons/PolandIcon";
import UsIcon from "components/Icons/FlagsIcons/UsIcon";


import art_design from "components/Icons/AppCategory/art_design.jpg";
import auto_vehicles from "components/Icons/AppCategory/auto_vehicles.jpg";
import beauty from "components/Icons/AppCategory/beauty.jpg";
import books_reference from "components/Icons/AppCategory/books_reference.jpg";
import business from "components/Icons/AppCategory/business.jpg";
import comics from "components/Icons/AppCategory/comics.jpg";
import communication from "components/Icons/AppCategory/communication.jpg";
import dating from "components/Icons/AppCategory/dating.jpg";
import education from "components/Icons/AppCategory/education.jpg";
import entertainment from "components/Icons/AppCategory/entertainment.jpg";
import events from "components/Icons/AppCategory/events.jpg";
import finance from "components/Icons/AppCategory/finance.jpg";
import food_drink from "components/Icons/AppCategory/food_drink.jpg";
import game from "components/Icons/AppCategory/game.jpg";
import health_fitness from "components/Icons/AppCategory/health_fitness.jpg";
import house_home from "components/Icons/AppCategory/house_home.jpg";
import libraries_demo from "components/Icons/AppCategory/libraries_demo.jpg";
import lifestyle from "components/Icons/AppCategory/lifestyle.jpg";
import maps_navigation from "components/Icons/AppCategory/maps_navigation.jpg";
import medical from "components/Icons/AppCategory/medical.jpg";
import music from "components/Icons/AppCategory/music.jpg";
import news_magazines from "components/Icons/AppCategory/news_magazines.jpg";
import parenting from "components/Icons/AppCategory/parenting.jpg";
import personalization from "components/Icons/AppCategory/personalization.jpg";
import photography from "components/Icons/AppCategory/photography.jpg";
import productivity from "components/Icons/AppCategory/productivity.jpg";
import shopping from "components/Icons/AppCategory/shopping.jpg";
import social from "components/Icons/AppCategory/social.jpg";
import sports from "components/Icons/AppCategory/sports.jpg";
import tools from "components/Icons/AppCategory/tools.jpg";
import travel_local from "components/Icons/AppCategory/travel_local.jpg";
import video_players_editors from "components/Icons/AppCategory/video_players_editors.jpg";
import weather from "components/Icons/AppCategory/weather.jpg";

export const COLOR_THEME_MODE = [
  { title: "Light", value: "light" },
  { title: "Dark", value: "dark" },
  { title: "Yellow", value: "yellow" },
  { title: "Pink", value: "pink" },
];

export const LANGUAGE_DROPDOWN = [
  { title: "English", value: "en", icon: <UsIcon /> },
  { title: "Polski", value: "pl", icon: <PolandIcon /> },
];

export const APP_CATEGORY = [
  {
    id: "app_category_books_reference",
    category: "Books & Reference",
    name: "",
    image: books_reference,
  },
  {
    id:"app_category_Entertainment",
    category: "Entertainment",
    name: "Themes,Sony LIV",
    image: entertainment,
  },
  {
    id:"app_category_Sports",
    category: "Sports",
    name: "",
    image: sports,
  },
  {
    id: "app_category_Tools",
    category: "Tools",
    name: "EX File Manager,Avast Mobile Security,Secure VPN,Files by Google,Data Restore Tool,Digital Wellbeing,Phone,Google Play services,Google,Gboard,Android Accessibility Suite,Speech Recognition and Synthesis from Google,Android System WebView,ARCore,Lens,Kidslox,Internet Blocker,EasyShare",
    image: tools,
  },
  {
    id: "app_category_auto&vehicle",
    category: "Auto & Vehicles",
    name: "Android Auto",
    image: auto_vehicles,
  },
  {
    id: "app_category_Finance",
    category: "Finance",
    name: "CRED,PhonePe",
    image: finance,
  },
  {
    id: "app_category_videoplayers_editors",
    category: "Video Players & Editors",
    name: "Google TV,YouTube",
    image: video_players_editors,
  },
  {
    id: "app_category_education",
    category: "Education",
    name: "BYJU'S The Learning App",
    image: education,
  },
  {
    id: "app_category_music",
    category: "Music",
    name: "Google Podcasts,YouTube Music,Spotify",
    image: music,
  },
  {
    id:"app_category_social",
    category: "Social",
    name: "Josh,Facebook,Moj Lite +,ShareChat,Moj,TiFamily",
    image: social,
  },
  {
    id: "app_category_library",
    category: "Libraries & Demo",
    name: "",
    image: libraries_demo,
  },
  {
    id: "app_category_Shopping",
    category: "Shopping",
    name: "vivo.com,Amazon",
    image: shopping,
  },
  {
    id: "app_category_Medical",
    category: "Medical",
    name: "",
    image: medical,
  },
  {
    id: "app_category_Personalization",
    category: "Personalization",
    name: "",
    image: personalization,
  },
  {
    id: "app_category_Game",
    category: "Game",
    name: "Royal Match,Pilot Simulator: Airplane Game,Tile Master 3D,Candy Crush Saga,Rolling Twins",
    image: game,
  },
  {
    id: "app_category_mapsnavigation",
    category: "Maps & Navigation",
    name: "",
    image: maps_navigation,
  },
  {
    id: "app_category_Business",
    category: "Business",
    name: "LinkedIn",
    image: business,
  },
  {
    id: "app_category_Communication",
    category: "Communication",
    name: "Chrome,Messenger,Messages,Meet,Gmail,AdvanceSMS,Calculator,Snapchat,Truecaller,Viber,Browser,WhatsApp,Signal",
    image: communication,
  },
  {
    id: "app_category_healthfitness",
    category: "Health & Fitness",
    name: "",
    image: health_fitness,
  },
  {
    id: "app_category_fooddrinks",
    category: "Food & Drink",
    name: "",
    image: food_drink,
  },
  {
    id: "app_category_news_magazine",
    category: "News & Magazines",
    name: "Dailyhunt,Google News",
    image: news_magazines,
  },
  {
    id: "app_category_travel",
    category: "Travel & Local",
    name: "Maps",
    image: travel_local,
  },
  {
    id: "app_category_Photography",
    category: "Photography",
    name: "Photos",
    image: photography,
  },
  {
    id: "app_category_Weather",
    category: "Weather",
    name: "",
    image: weather,
  },
  {
    id: "app_category_Productivity",
    category: "Productivity",
    name: "Drive,Docs,Sheets,Slides,Assistant,Google One,Calendar,MyJio",
    image: productivity,
  },
  {
    id: "app_category_Dating",
    category: "Dating",
    name: "",
    image: dating,
  },
  {
	  id: "app_category_Lifestyle",
    category: "Lifestyle",
    name: "Life360,Qustodio Kids",
    image: lifestyle,
  },
  {
    id: "app_category_House",
    category: "House & Home",
    name: "",
    image: house_home,
  },
  {
    id: "app_category_artdesign",
    category: "Art & Design",
    name: "",
    image: art_design,
  },
  {
    id: "app_category_Events",
    category: "Events",
    name: "",
    image: events,
  },
  {
    id: "app_category_Comics",
    category: "Comics",
    name: "",
    image: comics,
  },
  {
    id: "app_category_Beauty",
    category: "Beauty",
    name: "",
    image: beauty,
  },
  {
    id: "app_category_Parenting",
    category: "Parenting",
    name: "",
    image: parenting,
  },
];


export const SMS_COMMAND_DATA = [
  {
    id: 1,
    code: "LC",
    commandFor: "livelocation",
    subtext: "",
    goal: "viewCurrentLocation",
    result: "locationLinkResponse",
  },
  {
    id: 2,
    code: "PC",
    commandFor: "maincameraphoto",
    subtext: "",
    goal: "accessMainCameraPhoto",
    result: "CameraPhotoResult",
  },
  {
    id: 3,
    code: "PC 10",
    commandFor: "frontcameraphoto",
    subtext: "",
    goal: "accessFrontCameraPhoto",
    result: "CameraPhotoResult",
  },
  {
    id: 4,
    code: "AC 20",
    commandFor: "captureaudio",
    subtext: "",
    goal: "captureaudio",
    result:"uploadAudioToScheduler"
  },
  {
    id: 5,
    code: "TNO",
    commandFor: "startwifi",
    subtext: "",
    goal: "startWiFiForcefully",
    result: "startWiFiMonitoringPhone",
  },
  {
    id: 6,
    code: "TNF",
    commandFor: "stopwifi",
    subtext: "",
    goal: "stopWiFiForcefully",
    result: "stopWiFiMonitoringPhone",
  },
  {
    id: 7,
    code: "PR",
    commandFor: "playring",
    subtext: "",
    goal: "playRingCommand",
    result: "-",
  },
  {
    id: 8,
    code: "SC 1",
    commandFor: "synccontact",
    subtext: "",
    goal: "synccontact",
    result: "-",
  },
  {
    id: 9,
    code: "DC 1",
    commandFor: "disablecamera",
    subtext: "",
    goal: "disablecamera",
    result: "-",
  },
  {
    id: 10,
    code: "DC 0",
    commandFor: "enablecamera",
    subtext: "",
    goal: "enablecamera",
    result: "-",
  },
  // {
  //   id: 11,
  //   code: "LOCK",
  //   commandFor: "changescreenlockpassword",
  //   subtext: "NewPassword",
  //   goal: "changeLocknewpassword",
  //   result: "-",
  // },
  {
    id: 12,
    code: "CB",
    commandFor: "callback",
    subtext: "9999999999",
    goal: 'callBackCommand',
    result: "-",
  },
  {
    id: 13,
    code: "FQ",
    commandFor: "resetfiles",
    subtext: "",
    goal: "removeUnuploadedFiles",
    result:
      "useCommandForUploadDelay",
  },
];

// Serbian and  Arabic language pending mapping
export const countryToLanguageMap = {
  US: "en",
  PL: "pl",
};

export const Smscommmandcode = ["LC", "PC", "PC 1", "PC 10 ", " AC 20", "TNO", "TNF", "PR", "SC 1", " DC 1 ", "DC 0 ", "LOCK", "CB", "FQ"];



export const monthTranslations = {
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
  pl: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
};


// Day translations
export const dayTranslations = {
  en: {
    today: "Today",
    yesterday: "Yesterday"
  },
  pl: {
    today: "Dziś",
    yesterday: "Wczoraj"
  },
};

export const categoryTranslations = {
  en: ["Addiction","Adult","Alcohol/Drugs","Blogs","Business","Communication","Computer Security","Crypto","Culture","Dating","Education","Entertainment","Fashion","File Storage/Sharing/Cloud","Finance","Food","Gambling","Games","Government/Law","Hate/Bulling/Abuse","Health","Illegal","Informational","Job Search","Kids","Marketing","Nature","News","Personal","Pets and Animals","Plagiarism","Politics","Porn","Religious","Science/Technology","Search Engine","Sex","Shopping","Social Networking","Spam","Sports","Translation","Travel","Unknown","Unwanted","Vehicles","Violence","Weapons/Military"],
  fr: ["Addiction","Adulte","Alcool/Drogues","Blogs","Affaires","Communication","Sécurité informatique","Crypto","Culture","Rencontres","Éducation","Divertissement","Mode","Stockage/Partage/Cloud","Finance","Nourriture","Jeux d'argent","Jeux","Gouvernement/Droit","Haine/Intimidation/Abus","Santé","Illégal","Informatif","Recherche d'emploi","Enfants","Marketing","Nature","Actualités","Personnel","Animaux","Plagiat","Politique","Pornographie","Religieux","Science/Technologie","Moteur de recherche","Sexe","Shopping","Réseaux sociaux","Spam","Sports","Traduction","Voyage","Inconnu","Indésirable","Véhicules","Violence","Armes/Militaire"],
  de: ["Sucht","Erwachsene","Alkohol/Drogen","Blogs","Geschäft","Kommunikation","Computersicherheit","Krypto","Kultur","Dating","Bildung","Unterhaltung","Mode","Dateispeicherung/Freigabe/Cloud","Finanzen","Essen","Glücksspiel","Spiele","Regierung/Gesetz","Hass/Mobbing/Missbrauch","Gesundheit","Illegal","Information","Jobsuche","Kinder","Marketing","Natur","Nachrichten","Persönlich","Haustiere und Tiere","Plagiat","Politik","Pornografie","Religiös","Wissenschaft/Technologie","Suchmaschine","Sex","Einkaufen","Soziale Netzwerke","Spam","Sport","Übersetzung","Reisen","Unbekannt","Unerwünscht","Fahrzeuge","Gewalt","Waffen/Militär"],
  sp: ["Adicción","Adulto","Alcohol/Drogas","Blogs","Negocios","Comunicación","Seguridad informática","Cripto","Cultura","Citas","Educación","Entretenimiento","Moda","Almacenamiento/Compartir/Nube","Finanzas","Comida","Juego","Juegos","Gobierno/Ley","Odio/Acoso/Abuso","Salud","Ilegal","Informativo","Búsqueda de empleo","Niños","Marketing","Naturaleza","Noticias","Personal","Mascotas y animales","Plagio","Política","Pornografía","Religioso","Ciencia/Tecnología","Motor de búsqueda","Sexo","Compras","Redes sociales","Spam","Deportes","Traducción","Viaje","Desconocido","No deseado","Vehículos","Violencia","Armas/Militar"],
  nl: ["Verslaving", "Volwassen", "Alcohol/Drugs", "Blogs", "Zakelijk","Communicatie", "Computerbeveiliging", "Crypto", "Cultuur", "Dating","Onderwijs", "Vermaak", "Mode", "Bestand Opslaan/Delen/Cloud","Financiën", "Eten", "Gokken", "Spellen", "Overheid/Wet", "Haat/Pesten/Misbruik", "Gezondheid", "Illegaal", "Informatief", "Vacatures", "Kinderen", "Marketing", "Natuur", "Nieuws", "Persoonlijk","Huisdieren en Dieren", "Plagiaat", "Politiek", "Pornografie", "Religieus","Wetenschap/Technologie", "Zoekmachine", "Seks", "Winkelen", "Sociale Netwerken", "Spam", "Sport", "Vertaling", "Reizen", "Onbekend", "Ongewenst", "Voertuigen", "Geweld", "Wapens/Militair"],
  pl: ["Uzależnienie", "Dorosły", "Alkohol/Narkotyki", "Blogi", "Biznes","Komunikacja", "Bezpieczeństwo Komputerowe", "Krypto", "Kultura","Randki", "Edukacja", "Rozrywka", "Moda","Przechowywanie/Udostępnianie/Chmura", "Finanse", "Jedzenie","Hazard", "Gry", "Rząd/Prawo", "Nienawiść/Prześladowanie/Abuse", "Zdrowie", "Nielegalne", "Informacyjny", "Szukaj pracy", "Dzieci","Marketing", "Natura", "Wiadomości", "Osobiste","Zwierzęta domowe i Zwierzęta", "Plagiat", "Polityka", "Pornografia","Religijny", "Nauka/Technologia", "Wyszukiwarka", "Seks", "Zakupy","Sieci Społecznościowe", "Spam", "Sport", "Tłumaczenie", "Podróże","Nieznany", "Niechciany", "Pojazdy", "Przemoc", "Broń/Wojskowy"],
  sr: ["Зависност", "Пуниолетно", "Алкохол/Дроге", "Блогови", "Бизнис","Комуникација", "Компјутерска Безбедност", "Крипто", "Култура", "Упознавање","Едукација", "Забава", "Мода", "Складиштење/Дељење/Облак", "Финансије","Храна", "Клађење", "Игре", "Влада/Право","Мржња/Буллинг/Злоупотреба", "Здравље", "Нелегално", "Информативно","Тражим посао", "Деца", "Маркетинг", "Природа", "Новости", "Лично","Љубимци и Животиње", "Плагијат", "Политика", "Порнографија", "Религија","Наука/Технологија", "Претрага", "Секс", "Шопинг", "Друштвене Мреже","Спам", "Спорт", "Превод", "Путовање", "Непознато", "Нежељено","Возила", "Насиље", "Наређење/Војно"],
  tr: ["Bağımlılık", "Yetişkin", "Alkol/Uyuşturucu", "Bloglar", "İş","İletişim", "Bilgisayar Güvenliği", "Kripto", "Kültür", "Flört","Eğitim", "Eğlence", "Moda", "Dosya Depolama/Paylaşım/Bulut","Finans", "Yemek", "Kumar", "Oyunlar", "Hükümet/Hukuk","Nefret/Zorbalık/İstismar", "Sağlık", "Yasadışı", "Bilgilendirici","İş Arama", "Çocuklar", "Pazarlama", "Doğa", "Haberler", "Kişisel","Evcil Hayvanlar ve Hayvanlar", "İntihal", "Politika", "Pornografi","Dini", "Bilim/Teknoloji", "Arama Motoru", "Cinsellik", "Alışveriş","Sosyal Ağlar", "Spam", "Spor", "Çeviri", "Seyahat", "Bilinmeyen","İstenmeyen", "Araçlar", "Şiddet", "Silahlar/Askeri"],
  it: ["Dipendenza", "Adulto", "Alcool/Droghe", "Blog", "Affari","Comunicazione", "Sicurezza Informatica", "Crypto", "Cultura","Incontri", "Istruzione", "Intrattenimento", "Moda","Archiviazione/Condivisione/Cloud", "Finanza", "Cibo", "Gioco d'azzardo","Giochi", "Governo/Legge", "Odio/Bullismo/Abuso", "Salute", "Illegale","Informativo", "Ricerca lavoro", "Bambini", "Marketing", "Natura","Notizie", "Personale", "Animali domestici e Animali", "Plagio","Politica", "Pornografia", "Religioso", "Scienza/Tecnologia","Motore di ricerca", "Genere", "Shopping", "Social networking", "Spam","Sport", "Traduzione", "Viaggio", "Sconosciuto", "Indesiderato","Veicoli", "Violenza", "Armi/Militare"],
  id: ["Kecanduan", "Dewasa", "Alkohol/Narkoba", "Blog", "Bisnis","Komunikasi", "Keamanan Komputer", "Kripto", "Budaya", "Kencan","Pendidikan", "Hiburan", "Mode", "Penyimpanan/Berbagi/Awan","Keuangan", "Makanan", "Judi", "Game", "Pemerintah/Hukum","Kebencian/Bullying/Penyalahgunaan", "Kesehatan", "Ilegal", "Informasional","Cari Kerja", "Anak-anak", "Pemasaran", "Alam", "Berita", "Pribadi","Hewan Peliharaan dan Hewan", "Plagiarisme", "Politik", "Pornografi","Religius", "Sains/Teknologi", "Mesin Pencari", "Sex", "Belanja","Jejaring Sosial", "Spam", "Olahraga", "Terjemahan", "Perjalanan","Tidak Diketahui", "Tidak Diinginkan", "Kendaraan", "Kekerasan","Senjata/Militer"],
  ro: ["Dependență", "Adult", "Alcool/Droguri", "Bloguri", "Afaceri","Comunicare", "Securitate Informatică", "Cripto", "Cultură", "Întâlniri","Educație", "Divertisment", "Modă", "Stocare/Partajare/Cloud","Finanțe", "Mâncare", "Jocuri de noroc", "Jocuri", "Guvern/Lege","Ură/Hărțuire/Abuz", "Sănătate", "Ilegal", "Informațional", "Căutare de job","Copii", "Marketing", "Natură", "Știri", "Personal", "Animale de companie și animale","Plagiat", "Politică", "Pornografie", "Religios", "Știință/Tehnologie","Motor de căutare", "Sex", "Cumpărături", "Rețele sociale", "Spam","Sport", "Traducere", "Călătorii", "Necunoscut", "Nedorit","Vehicule", "Violență", "Arme/Militar"],
  uk: ["Залежність", "Дорослі", "Алкоголь/Наркотики", "Блоги", "Бізнес","Комунікація", "Комп’ютерна безпека", "Крипто", "Культура", "Знайомства","Освіта", "Розваги", "Мода", "Зберігання/Обмін/Хмара", "Фінанси","Їжа", "Азартні ігри", "Ігри", "Уряд/Закон", "Ненависть/Булінг/Зловживання","Здоров’я", "Нелегальне", "Інформаційне", "Пошук роботи", "Діти","Маркетинг", "Природа", "Новини", "Особисте", "Домашні тварини та тварини","Плагіат", "Політика", "Порнографія", "Релігійне", "Наука/Технології","Пошукова система", "Секс", "Шопінг", "Соціальні мережі", "Спам","Спорт", "Переклад", "Подорожі", "Невідомо", "Небажане","Транспорт", "Насильство", "Зброя/Військове"],
  ar: ["إدمان", "للكبار", "كحول/مخدرات", "مدونات", "أعمال","اتصال", "أمن الحاسوب", "تشفير", "ثقافة", "مواعدة","تعليم", "ترفيه", "موضة", "تخزين/مشاركة/سحابة", "تمويل","طعام", "قمار", "ألعاب", "حكومة/قانون", "كراهية/تنمر/إساءة","صحة", "غير قانوني", "معلوماتي", "بحث عن عمل", "أطفال","تسويق", "طبيعة", "أخبار", "شخصي", "حيوانات أليفة وحيوانات","انتحال", "سياسة", "إباحية", "ديني", "علوم/تكنولوجيا","محرك بحث", "جنس", "تسوق", "شبكات اجتماعية", "بريد عشوائي","رياضة", "ترجمة", "سفر", "مجهول", "غير مرغوب","مركبات", "عنف", "أسلحة/عسكري"],
  ga: ["Andúil", "Duine fásta", "Alcól/Drugaí", "Blaganna", "Gnó","Cumarsáid", "Slándáil Ríomhaireachta", "Crypto", "Cultúr", "Dul ag dul","Oideachas", "Siamsaíocht", "Faisean", "Stóráil/Comhroinnt/Scamall","Airgeadas", "Bia", "Cearrbhachas", "Cluichí", "Rialtas/Dlí","Fuath/Bulaíocht/Mí-úsáid", "Sláinte", "Neamhdhleathach", "Faisnéiseach","Cuardach Poist", "Páistí", "Margaíocht", "Nádúr", "Nuacht","Pearsanta", "Peataí agus Ainmhithe", "Plagiúlacht", "Polaitíocht","Pornagrafaíocht", "Reiligiúnach", "Eolaíocht/Teicneolaíocht","Inneall Cuardaigh", "Gnéas", "Siopadóireacht", "Líonrú Sóisialta", "Spam","Spóirt", "Aistriúchán", "Taisteal", "Anaithnid", "Neamhiomlán","Feithiclí", "Foréigean", "Arm/Míleata"],
  fl: ["Pagkagumon", "Pang-adulto", "Alak/Droga", "Mga Blog", "Negosyo","Komunikasyon", "Seguridad sa Computer", "Kripto", "Kultura", "Pakikipag-date","Edukasyon", "Libangan", "Moda", "Imbakan/Pagbabahagi/Cloud","Pananalapi", "Pagkain", "Pagsusugal", "Mga Laro", "Pamahalaan/Batas","Pagkapoot/Panliligalig/Pang-aabuso", "Kalusugan", "Ilegal", "Impormasyon","Paghahanap ng Trabaho", "Mga Bata", "Marketing", "Kalikasan", "Balita","Personal", "Alagang Hayop at Hayop", "Plagiarism", "Politika", "Pornograpiya","Pananampalataya", "Agham/ Teknolohiya", "Search Engine", "Seks","Pamimili", "Social Networking", "Spam", "Isports", "Pagsasalin","Paglalakbay", "Hindi Kilala", "Hindi Nais", "Sasakyan", "Karahasan","Armas/Militar"],
  ch: ["成瘾", "成人", "酒精/毒品", "博客", "商业","沟通", "计算机安全", "加密", "文化", "约会","教育", "娱乐", "时尚", "文件存储/共享/云", "金融","食物", "赌博", "游戏", "政府/法律", "仇恨/欺凌/虐待","健康", "非法", "信息类", "找工作", "儿童","营销", "自然", "新闻", "个人", "宠物和动物","抄袭", "政治", "色情", "宗教", "科学/技术","搜索引擎", "性", "购物", "社交网络", "垃圾邮件","体育", "翻译", "旅行", "未知", "不需要","车辆", "暴力", "武器/军事"],
  il: ["התמכרות", "מבוגרים", "אלכוהול/סמים", "בלוגים", "עסקים","תקשורת", "אבטחת מחשבים", "קריפטו", "תרבות", "היכרויות","חינוך", "בידור", "אופנה", "אחסון/שיתוף/ענן", "כספים","אוכל", "הימורים", "משחקים", "ממשלה/חוק", "שנאה/בריונות/התעללות","בריאות", "בלתי חוקי", "מידע", "חיפוש עבודה", "ילדים","שיווק", "טבע", "חדשות", "אישי", "חיות מחמד ובעלי חיים","פלגיאט", "פוליטיקה", "פורנוגרפיה", "דתי", "מדע/טכנולוגיה","מנוע חיפוש", "מין", "קניות", "רשתות חברתיות", "ספאם","ספורט", "תרגום", "נסיעות", "לא ידוע", "לא רצוי","רכבים", "אלימות", "נשק/צבאי"],
  mk: ["Зависност", "Возрасни", "Алкохол/Дроги", "Блогови", "Бизнис","Комуникација", "Компјутерска безбедност", "Крипто", "Култура", "Запознавање","Образование", "Забава", "Мода", "Складирање/Споделување/Облак","Финансии", "Храна", "Коцкање", "Игри", "Влада/Закон","Омраза/Малтретирање/Злоупотреба", "Здравје", "Нелегално", "Информативно","Барање работа", "Деца", "Маркетинг", "Природа", "Вести", "Лично","Домашни миленици и Животни", "Плагијат", "Политика", "Порнографија","Религиозно", "Наука/Технологија", "Пребарувач", "Секс", "Купување","Социјални мрежи", "Спам", "Спорт", "Превод", "Патување","Непознато", "Несакано", "Возила", "Насилство", "Оружје/Војска"]
};

export const excludedViews = ['whatsapp', 'sms', 'screen', 'facebook', 'viber', 'hike', 'kik', 'skype', 'tinder', 'hangout', 'line', 'instagram', 'snapchat', 'zolo', 'imo', 'bip', 'justtalk', 'botim', 'signal', 'discord', 'vk', 'tiktok', 'twitter', 'googlemeet', 'wechat', 'qq', 'telegram', 'kakoa', 'calls', 'keylogger', 'search', 'youtube', 'webHistory','location','geoFence','dataManagement', 'gg', 'threema', 'twitch', 'badoo', 'mteams', 'chatgpt', 'gemini', 'roblox','mail'];
export const isexcludedpathname =['/systemLogEvents','/livepanel','/contacts','/remoteCommands','/screenTime','/webFilter','/notifications','/schedule','/location','/apps','/changePassword',"/appUsage"];